import React, { useCallback, useEffect, useState } from 'react';

import useCreateOrUpdateExternalMarketingModal from '@hooks/useCreateOrUpdateExternalMarketingModal';
import { addParamToUrl } from '@utils/queryStringHelper';

import { MarketingModalProps } from '.';
import ModalContent from './Content';

const MarketingModalLayout = (props: MarketingModalProps) => {
  const [customUrlWithGuid, setCustomUrlWithGuid] = useState<string>(props.customUrl);
  const [offerLinkWithGuid, setOfferLinkWithGuid] = useState<string>(props.offerLink);
  const [modalId, setModalId] = useState<number | string>(props.id || undefined);

  const { mutateAsync: createOrUpdateExternalMarketingModalAsync, isLoading } =
    useCreateOrUpdateExternalMarketingModal();

  const createOrUpdateExternalMarketingModal = useCallback(async () => {
    const {
      buttonText,
      customUrl,
      disclosure,
      externalSource,
      externalSourceId,
      highlight,
      modalType,
      name,
      newsletterId,
      subtitle,
      title,
      offerLink,
    } = props;
    try {
      const res = await createOrUpdateExternalMarketingModalAsync({
        button_text: buttonText,
        custom_url: customUrl,
        disclosure: disclosure,
        external_source: externalSource,
        external_source_id: externalSourceId,
        header: highlight || '',
        highlighted_cta: highlight ?? '',
        modal_type: modalType,
        name: name || `${externalSource}-${externalSourceId}`,
        newsletter_id: newsletterId,
        subtitle: subtitle || '',
        title: title || name || '',
      });
      if (res.custom_url && res.guid) {
        setCustomUrlWithGuid(addParamToUrl(customUrl, 'modal', res.guid));
      }
      if (offerLink && res.guid) {
        setOfferLinkWithGuid(addParamToUrl(offerLink, 'modal', res.guid));
      }
      setModalId(res.id);
    } catch (error) {
      console.error('Error finding or creating marketing modal:', error);
    }
  }, [props, createOrUpdateExternalMarketingModalAsync]);

  useEffect(() => {
    if (props.externalSource && props.externalSourceId) {
      createOrUpdateExternalMarketingModal();
    }
  }, [props.externalSource, props.externalSourceId, createOrUpdateExternalMarketingModal]);

  if (isLoading || !modalId) {
    return null;
  }

  return (
    <ModalContent
      {...props}
      customUrl={customUrlWithGuid}
      offerLink={offerLinkWithGuid}
      id={modalId}
    />
  );
};

export default MarketingModalLayout;
